import { Controller } from "@hotwired/stimulus"

// Fades a server-rendered toast in, then removes it. Used by Turbo Stream
// responses that need to say something without re-rendering the page.
export default class extends Controller {
  static values = { duration: { type: Number, default: 5000 } }

  connect() {
    requestAnimationFrame(() => {
      this.element.classList.remove("opacity-0", "translate-y-2")
    })

    this.timeout = setTimeout(() => this.dismiss(), this.durationValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.classList.add("opacity-0", "translate-y-2")
    setTimeout(() => this.element.remove(), 300)
  }
}
